module.exports = __webpack_public_path__ + "static/media/drippl-white-bg.7d4183c8.png";